import React from 'react';
import {Text, View} from 'react-native';

import {Code, Heading, Spacer} from '/component/base/Storybook';
import {generateComponentCallback} from '/util/component.util';

import ProfileHeader from '../ProfileHeader';

import {styles} from './ProfileHeader.style';

export default () => (
  <>
    <Heading level={2}>Profile Header Component Title</Heading>
    <Spacer size={16} />
    <Text>See coach or user profile as an example. </Text>
    <Spacer size={16} />
    <View style={styles.wrapper}>
      <ProfileHeader
        title={generateComponentCallback({
          component: (
            // @ts-expect-error TS(2769): No overload matches this call.
            <Text variant="small" emphasis="low">
              {'text'}
            </Text>
          ),
        })}
        name="name"
        email="email"
        avatarUrl="https://reactnative.dev/img/tiny_logo.png"
        isCoach={true}
      />
    </View>

    <Spacer size={20} />
    <Code>{'title={() => ('}</Code>
    <Code>{'  <Text'}</Code>
    <Code>{'   variant="small"'}</Code>
    <Code>{'   emphasis="low"'}</Code>
    <Code>{'  >'}</Code>
    <Code>{"     {'text'}"}</Code>
    <Code>{'  </Text>'}</Code>
    <Code>{')}'}</Code>
  </>
);
